import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FiltersPage } from './filters.page';

const routes: Routes = [
  {
    path: '',
    component: FiltersPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FiltersPageRoutingModule {}
